var map = {
	"./Photo.jpg": 71,
	"./about.jpg": 72,
	"./about1.jpg": 73,
	"./hero.jpg": 74,
	"./hero2.jpg": 75,
	"./hero3.jpg": 76,
	"./jeral.jpg": 77,
	"./projects.jpg": 26,
	"./projects/project1.png": 32,
	"./projects/project2.2.png": 78,
	"./projects/project2.png": 33,
	"./projects/project3.png": 34,
	"./projects/project4_1.png": 35,
	"./skills/bootstrap-.svg": 36,
	"./skills/css-.svg": 37,
	"./skills/expressjs-.svg": 79,
	"./skills/git-.svg": 38,
	"./skills/github-.svg": 39,
	"./skills/html-.svg": 40,
	"./skills/javascript-.svg": 41,
	"./skills/mongodb-.svg": 42,
	"./skills/mysql.png": 43,
	"./skills/node-.svg": 44,
	"./skills/react-.svg": 45,
	"./skills/redux-.svg": 46
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70;